import styled from 'styled-components';

export const Svg = styled.svg`
  width: 32px;
  height: 32px;
`;
